'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeInLeft = {
  from: {
    opacity: 0,
    transform: (0, _utils.translate3d)('-100%', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInLeft;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-in-left.js
// module id = 212
// module chunks = 54990529738226 257444579329143